<template>
  <div class="animated fadeIn control-stock">
    <b-row>
      <b-col xl="12">
        <b-form>
          <b-card header="Articulos">
            <b-table 
                small 
                responsive="sm"
                class="registro-ordenes" 
                :items="renglones" 
                :fields="fields">
              <template slot="cantidadControl" slot-scope="data">
                  <input type="number"
                      step="1"
                      v-model="data.item.cantidadControl"/>
              </template>
            </b-table>
          </b-card>

          <b-card header="Información Adicional">
            <b-form-group
              label="Observaciones"
              label-for="observaciones">
              <b-form-textarea
                id="observaciones"
                v-model="$v.observaciones.$model" 
                rows="3"
                max-rows="6"
                :state="observacionesValidas"
                @blur.native="validate">
              </b-form-textarea>
              <b-form-invalid-feedback id="observacionesFeedback">
                {{ observacionesInvalidasMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>
          </b-card>
        </b-form>
      </b-col>
    </b-row>

    <app-a-b-m-button
      @save="save"
      @cancel="goList">
    </app-a-b-m-button>  

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>
  </div>
</template>

<script>
import ABMButtons from '../shared/abmButtons.vue';
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs';
import { required, numeric, maxLength } from 'vuelidate/lib/validators';
import moment from 'moment';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'controlStock/getField',
  mutationType: 'controlStock/updateField',
});

export default {
  name: 'ControlesStockABM',
  components: {
    appABMButton: ABMButtons,
    appMensaje: Mensaje,
    appConfirm: Confirm
  },
  mixins: [ 
    msjModal,
    confirmModal 
  ],
  data () {
    return {
      noValidar: true,
      observacionesValidas: null,
      observacionesInvalidasMsj: '',

      fields: [
        {
          key: 'articulo',
        },
        {
          key: 'cantidadStock',
          label: 'Stock',
          class: 'text-right'
        },
        {
          key: 'cantidadControl',
          label: 'Control',
          class: 'text-right'
        },
      ],

      labelCols: 2,
    }
  },
  computed: {
    ...mapFields([
      'id',
      'observaciones',
      'renglones',
    ]),
  },  
  created() {
    let controlStockId = 0;
    if (this.$route.params){
      if (this.$route.params.id){
        controlStockId = this.$route.params.id;
      }
    }

    this.showSpinner();
    this.$store.dispatch('controlStock/inicializar', controlStockId)
      .catch(error => this.showErrorMsj(error))
      .finally(() => this.hideSpinner());
  },
  methods: {
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar){
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == "observaciones" || validarTodos) {
        if (this.$v.observaciones.$error) {
          this.observacionesValidas = false;
          if (!this.$v.observaciones.maxLength) {
            this.observacionesInvalidasMsj = 'Las observaciones sólo puede contener hasta 5000 caracteres';
          }
        } else {
          this.observacionesValidas = null;
          this.observacionesInvalidasMsj = '';
        }
      }
    },
    save () {
      let save = true;

      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      this.$v.$touch();

      if (this.$v.$anyError) {
        this.displayErrores();
      } else {
        if (save) {
          this.showModalConfirm('¿Desea finalizar el control y ajustar los artículos con diferencias de stock?', 
                this.saveControl.bind(this, true), 'Si', this.saveControl.bind(this, false), 'No')
        }
      }
    },
    saveControl(finalizar) {
      this.showSpinner();
      this.$store.dispatch('controlStock/save', finalizar)
        .then(() => this.showModalMsj('Los cambios se registraron con éxito', this.goList, this.goList, 'light'))
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    goList() {
      this.$router.push({ name: "ControlesStock" });
    },
  },
  validations: {
    observaciones: {
      maxLength: maxLength(5000)
    },
  },  
  watch: {
  }    
}
</script>

<style>
  .control-stock .registro-ordenes table thead tr th {
    border-top: none;
  }
  .control-stock .registro-ordenes table td {
    vertical-align: middle;
    border: none;
  }
  .control-stock .registro-ordenes table td[aria-colindex="1"] {
    width: 70%;
  }
  .control-stock .registro-ordenes table td[aria-colindex="2"],
  .control-stock .registro-ordenes table td[aria-colindex="3"] {
    width: 15%;
  }
  .control-stock .registro-ordenes table td input {
    width: 70%;
    left: 5%;
    margin: 0; 
    text-align: right;
    -moz-appearance:textfield;
    border: none;
    border-bottom: 1px solid rgba(32, 168, 216, 0.8);
  }
  .control-stock .registro-ordenes table td input[type=number]::-webkit-inner-spin-button, 
  .control-stock .registro-ordenes table td input[type=number]::-webkit-outer-spin-button { 
    -webkit-appearance: none; 
  }
</style>
